import React from 'react';
import map from '../assets/map.svg';
import './GlobalOperationsMap.css';
import { ArrowUp } from "lucide-react";


const GlobalOperationsMap = () => {
 const stats = [
    { value: <ArrowUp size={20} />, label: 'Increasing Global Share', color: 'orange' },
  { value: '10M+ units', label: 'Annual Production', color: 'orange' },
  { value: '14+', label: 'Countries Served', color: 'orange' },
  { value: 'Leading', label: 'One of the Largest Manufacturer', color: 'green' },
];



  return (
    <div className="global-map-container">
      <div className="global-map-maxwidth">
        {/* Map Image */}
        <div className="map-section">
          <img src={map} alt="Global Operations Map" className="map-image" />
        </div>

        {/* Statistics Grid */}
        <div className="stats-grid">
          {stats.map((stat, index) => (
            <div key={index} className="stat-card">
              <div className={`stat-border ${stat.color}`}>
                <div className="stat-value">{stat.value}</div>
                <div className="stat-label">{stat.label}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default GlobalOperationsMap;
